export default {
  title: 'Fornecedores de entrega',
};
